// src/components/FAQDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
    {
        question: "How do I add a new friend?",
        answer: "Navigate to the 'Find People' section in the sidebar. You can search for other users by their exact email address and send them a connection request."
    },
    {
        question: "How do I change my profile picture or name?",
        answer: "Click on your name and avatar at the top of the sidebar. A menu will appear with an 'Edit Profile' option. From there, you can update your display name and upload a new photo."
    },
    {
        question: "Is my data secure?",
        answer: "Yes, your privacy and security are a top priority. All messages and user data are stored securely using Google's Firebase services. You can review our full Privacy Statement from the sidebar for more details."
    },
    {
        question: "How do voice messages work?",
        answer: "When the text input is empty, a microphone icon will appear. Click it to start recording (up to 20 seconds). Click the stop icon when you are done. You can then review your recording before sending or deleting it."
    }
];

const FAQDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} scroll="paper" fullWidth maxWidth="sm">
      <DialogTitle>Frequently Asked Questions</DialogTitle>
      <DialogContent dividers>
        {faqs.map((faq, index) => (
            <Accordion key={index} sx={{ my: 1 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography color="text.secondary">{faq.answer}</Typography>
                </AccordionDetails>
            </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FAQDialog;